// Member Portal brand tokens — for ACUL screens that interrupt a member who is
// ALREADY INSIDE the portal, rather than screens on the way in.
//
// ⚠️ THIS IS NOT applyCareSuperBrand(), AND THE DIFFERENCE IS DELIBERATE.
// That function themes the SIGNUP journey: a light green/indigo palette with
// pill buttons, copied from Mark's reference screenshots of the real CareSuper
// JOIN journey. It is intentionally unlike the portal.
//
// Using it on mfa-otp-challenge was wrong, and produced the exact complaint
// that prompted this file: the step-up screen matched neither the portal the
// member had just been pulled out of, nor stock Universal Login, so it read as
// a generic hosted page carrying somebody's branding. A member mid-session on
// app-v2.azuremark.co should feel the challenge is part of the app.
//
// Tokens below are read off the portal's own markup rather than eyeballed:
//
//   page background  bg-gray-50        #F9FAFB   ProtectedRoute.jsx
//   panel            bg-white          #FFFFFF   Beneficiaries.jsx
//                    rounded-xl        12px
//                    border-gray-100   #F3F4F6
//                    shadow-sm
//   heading          text-gray-900     #111827   font-bold
//   body copy        text-gray-600     #4B5563
//   primary button   #00A591 (teal)    rounded-lg 8px
//   font             'Inter', sans-serif
//
// Call AFTER applyAuth0Theme(...) so it wins over the tenant's generic
// Universal Login branding.
const PORTAL_TEAL = "#00A591";
const PORTAL_TEAL_HOVER = "#008577";
const PORTAL_HEADING = "#111827";
const PORTAL_BODY_TEXT = "#4B5563";
const PORTAL_PAGE_BG = "#F9FAFB";
const PORTAL_PANEL_BORDER = "#F3F4F6";

export function applyMemberPortalBrand(): void {
  const root = document.documentElement.style;

  root.setProperty("--ul-theme-color-primary-button", PORTAL_TEAL);
  root.setProperty("--ul-theme-color-primary-button-label", "#ffffff");
  root.setProperty("--ul-theme-color-base-focus-color", PORTAL_TEAL);
  root.setProperty("--ul-theme-color-base-hover-color", PORTAL_TEAL_HOVER);
  root.setProperty("--ul-theme-color-links-focused-components", PORTAL_TEAL);

  root.setProperty("--ul-theme-color-secondary-button-border", PORTAL_TEAL);
  root.setProperty("--ul-theme-color-secondary-button-label", PORTAL_TEAL);

  // The page behind the card is the portal's own grey, not white — that single
  // token does most of the work of making the card read as a portal panel.
  root.setProperty("--ul-theme-page-bg-background-color", PORTAL_PAGE_BG);
  root.setProperty("--ul-theme-color-widget-background", "#ffffff");
  root.setProperty("--ul-theme-color-widget-border", PORTAL_PANEL_BORDER);

  root.setProperty("--ul-theme-color-header", PORTAL_HEADING);
  root.setProperty("--ul-theme-color-body-text", PORTAL_BODY_TEXT);
  root.setProperty("--ul-theme-color-input-labels-placeholders", "#6B7280");
  root.setProperty("--ul-theme-color-input-filled-text", PORTAL_HEADING);
  root.setProperty("--ul-theme-color-input-border", "#D1D5DB");
  root.setProperty("--ul-theme-color-input-background", "#FFFFFF");

  // Portal buttons are rounded-lg rectangles, NOT the signup journey's pills.
  root.setProperty("--ul-theme-border-button-border-radius", "8px");
  root.setProperty("--ul-theme-border-input-border-radius", "8px");
  root.setProperty("--ul-theme-border-widget-corner-radius", "12px");

  root.setProperty("--ul-theme-font-title-weight", "700");
}

export const MEMBER_PORTAL_COLORS = {
  teal: PORTAL_TEAL,
  tealHover: PORTAL_TEAL_HOVER,
  heading: PORTAL_HEADING,
  bodyText: PORTAL_BODY_TEXT,
  pageBg: PORTAL_PAGE_BG,
  panelBorder: PORTAL_PANEL_BORDER,
} as const;
